/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DGSegregationRuleDto } from '../model';
// @ts-ignore
import type { DeleteDGSegregationRulesDto } from '../model';
// @ts-ignore
import type { UpsertDGSegregationRulesDto } from '../model';
/**
 * DGSegregationRuleApi - axios parameter creator
 */
export const DGSegregationRuleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DeleteDGSegregationRulesDto} [deleteDGSegregationRulesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dGSegregationRuleDeleteBulk: async (deleteDGSegregationRulesDto?: DeleteDGSegregationRulesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/DGSegregationRule/DeleteBulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteDGSegregationRulesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dGSegregationRuleGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/DGSegregationRule/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertDGSegregationRulesDto} [upsertDGSegregationRulesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dGSegregationRuleUpsertBulk: async (upsertDGSegregationRulesDto?: UpsertDGSegregationRulesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/DGSegregationRule/UpsertBulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertDGSegregationRulesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DGSegregationRuleApi - functional programming interface
 */
export const DGSegregationRuleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DGSegregationRuleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {DeleteDGSegregationRulesDto} [deleteDGSegregationRulesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dGSegregationRuleDeleteBulk(deleteDGSegregationRulesDto?: DeleteDGSegregationRulesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dGSegregationRuleDeleteBulk(deleteDGSegregationRulesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DGSegregationRuleApi.dGSegregationRuleDeleteBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dGSegregationRuleGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DGSegregationRuleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dGSegregationRuleGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DGSegregationRuleApi.dGSegregationRuleGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertDGSegregationRulesDto} [upsertDGSegregationRulesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dGSegregationRuleUpsertBulk(upsertDGSegregationRulesDto?: UpsertDGSegregationRulesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DGSegregationRuleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dGSegregationRuleUpsertBulk(upsertDGSegregationRulesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DGSegregationRuleApi.dGSegregationRuleUpsertBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DGSegregationRuleApi - factory interface
 */
export const DGSegregationRuleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DGSegregationRuleApiFp(configuration)
    return {
        /**
         * 
         * @param {DGSegregationRuleApiDGSegregationRuleDeleteBulkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dGSegregationRuleDeleteBulk(requestParameters: DGSegregationRuleApiDGSegregationRuleDeleteBulkRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.dGSegregationRuleDeleteBulk(requestParameters.deleteDGSegregationRulesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dGSegregationRuleGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<DGSegregationRuleDto>> {
            return localVarFp.dGSegregationRuleGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DGSegregationRuleApiDGSegregationRuleUpsertBulkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dGSegregationRuleUpsertBulk(requestParameters: DGSegregationRuleApiDGSegregationRuleUpsertBulkRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<DGSegregationRuleDto>> {
            return localVarFp.dGSegregationRuleUpsertBulk(requestParameters.upsertDGSegregationRulesDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for dGSegregationRuleDeleteBulk operation in DGSegregationRuleApi.
 */
export interface DGSegregationRuleApiDGSegregationRuleDeleteBulkRequest {
    readonly deleteDGSegregationRulesDto?: DeleteDGSegregationRulesDto
}

/**
 * Request parameters for dGSegregationRuleUpsertBulk operation in DGSegregationRuleApi.
 */
export interface DGSegregationRuleApiDGSegregationRuleUpsertBulkRequest {
    readonly upsertDGSegregationRulesDto?: UpsertDGSegregationRulesDto
}

/**
 * DGSegregationRuleApi - object-oriented interface
 */
export class DGSegregationRuleApi extends BaseAPI {
    /**
     * 
     * @param {DGSegregationRuleApiDGSegregationRuleDeleteBulkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dGSegregationRuleDeleteBulk(requestParameters: DGSegregationRuleApiDGSegregationRuleDeleteBulkRequest = {}, options?: RawAxiosRequestConfig) {
        return DGSegregationRuleApiFp(this.configuration).dGSegregationRuleDeleteBulk(requestParameters.deleteDGSegregationRulesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dGSegregationRuleGetAll(options?: RawAxiosRequestConfig) {
        return DGSegregationRuleApiFp(this.configuration).dGSegregationRuleGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DGSegregationRuleApiDGSegregationRuleUpsertBulkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dGSegregationRuleUpsertBulk(requestParameters: DGSegregationRuleApiDGSegregationRuleUpsertBulkRequest = {}, options?: RawAxiosRequestConfig) {
        return DGSegregationRuleApiFp(this.configuration).dGSegregationRuleUpsertBulk(requestParameters.upsertDGSegregationRulesDto, options).then((request) => request(this.axios, this.basePath));
    }
}

